import { create } from "zustand";


export enum CrossAppSignal {
  WRITE_RUNNING = "writeRunning",
  REWRITE_RUNNING = "rewriteRunning",
  DESCRIBE_RUNNING = "describeRunning",
  AGENTIC_OUTLINE_RUNNING = "agenticOutlineRunning",
  AGENTIC_CHARACTER_RUNNING = "agenticCharacterRunning",
  AGENTIC_WORLDBUILDING_RUNNING = "agenticWorldbuildingRunning",
  AGENTIC_CAST_RUNNING = "agenticCastRunning",
  CHAT_RESTORED_FROM_TRASH = "chatRestoredFromTrash",
  FEEDBACK_RUNNING = "feedbackRunning",
}

// Helper to generate a consistent signal ID for plugins
export const getPluginSignal = (pluginId: string) => `plugin:${pluginId}`;

// Helper to generate a signal ID for chapter CTA shimmer
export const getChapterCTASignal = (chapterId: string) => `cta-chapter:${chapterId}`;

// Helper to generate a signal ID for character trait CTA shimmer
export const getTraitCTASignal = (characterId: string, traitId: string) => `cta-trait:${characterId}:${traitId}`;

// Helper to generate a signal ID for worldbuilding trait CTA shimmer
export const getWorldbuildingTraitCTASignal = (entryId: string, traitId: string) => `cta-wb-trait:${entryId}:${traitId}`;

// Helper to generate a signal ID for synopsis CTA shimmer
export const getSynopsisCTASignal = () => "cta-synopsis";

type CrossAppSignalState = {
  // Signals as top-level properties for optimal re-render behavior
  // Uses string keys to support both enum signals and dynamic plugin signals
  signals: Record<string, boolean>;
  // Optional data payload for signals that need to pass additional information
  signalData: Record<string, any>;

  // Actions
  setSignalActive: (signal: string, active: boolean, data?: any) => void;
  getSignalData: (signal: string) => any;
  clearSignalData: (signal: string) => void;
};

export const useCrossAppSignalStore = create<CrossAppSignalState>((set, get) => ({
  signals: {
    [CrossAppSignal.WRITE_RUNNING]: false,
    [CrossAppSignal.REWRITE_RUNNING]: false,
    [CrossAppSignal.DESCRIBE_RUNNING]: false,
    [CrossAppSignal.AGENTIC_OUTLINE_RUNNING]: false,
    [CrossAppSignal.AGENTIC_CHARACTER_RUNNING]: false,
    [CrossAppSignal.AGENTIC_WORLDBUILDING_RUNNING]: false,
    [CrossAppSignal.AGENTIC_CAST_RUNNING]: false,
    [CrossAppSignal.CHAT_RESTORED_FROM_TRASH]: false,
    [CrossAppSignal.FEEDBACK_RUNNING]: false,
  },
  signalData: {},
  setSignalActive: (signal, active, data) =>
    set((state) => ({
      signals: { ...state.signals, [signal]: active },
      signalData: data !== undefined ? { ...state.signalData, [signal]: data } : state.signalData,
    })),
  getSignalData: (signal) => get().signalData[signal],
  clearSignalData: (signal) =>
    set((state) => {
      const newSignalData = { ...state.signalData };
      delete newSignalData[signal];
      return { signalData: newSignalData };
    }),
}));
